<template>
  <div class="page-drawer bg-bgDefault">
    <slot name="drawer-content" />
  </div>
</template>

<style lang="less" scoped>
.page-drawer {
  height: 100%;
  width: 100%;
  max-width: 400px;
  min-width: 400px;
  border-right: 1px solid rgb(var(--v-theme-strokeDefault));
}
</style>
